// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as TailwindMerge from "tailwind-merge";
import * as Skillet$LiteracyplanetTupperware from "../v2/Skillet.res.mjs";
import * as TickIcon$LiteracyplanetTupperware from "../v2/TickIcon.res.mjs";
import * as CrossIcon$LiteracyplanetTupperware from "../v2/CrossIcon.res.mjs";
import * as NextArrow$LiteracyplanetTupperware from "../v2/NextArrow.res.mjs";
import * as PrevArrow$LiteracyplanetTupperware from "../v2/PrevArrow.res.mjs";
import * as V2ExerciseContext$LiteracyplanetTupperware from "../v2/V2ExerciseContext.res.mjs";
import * as MarkButtonStatesHook$LiteracyplanetTupperware from "../v2/MarkButtonStatesHook.res.mjs";
import * as PilotEndScreenContainer$LiteracyplanetTupperware from "./PilotEndScreenContainer.res.mjs";

function PilotQuestionContent$Button(props) {
  var __disabled = props.disabled;
  var disabled = __disabled !== undefined ? __disabled : false;
  return React.createElement("button", {
              className: TailwindMerge.twMerge("cursor-pointer mr-2.5 flex items-center justify-center font-bold select-none w-24 h-12 text-5 rounded-3xl", props.className),
              disabled: disabled,
              onClick: props.onClick
            }, props.children);
}

var Button = {
  make: PilotQuestionContent$Button
};

function PilotQuestionContent$MarkButton(props) {
  return React.createElement(PilotQuestionContent$Button, {
              disabled: props.disabled,
              onClick: props.onClick,
              className: TailwindMerge.twMerge("justify-self-center", props.className),
              children: "Submit"
            });
}

var MarkButton = {
  make: PilotQuestionContent$MarkButton
};

function PilotQuestionContent$BehaviourMarkButton(props) {
  var markState = MarkButtonStatesHook$LiteracyplanetTupperware.use();
  if (typeof markState !== "object") {
    switch (markState) {
      case "QuestionNotAttempted" :
          return React.createElement(PilotQuestionContent$MarkButton, {
                      disabled: true,
                      className: "text-white bg-pilotDisabledButton cursor-auto",
                      onClick: (function (param) {
                          
                        })
                    });
      case "QuestionMarked" :
      case "AssessmentMode" :
          return null;
      
    }
  } else {
    var cb = markState._0;
    return React.createElement(PilotQuestionContent$MarkButton, {
                className: "text-white bg-pilotButton hover:bg-pilotHoverButton",
                onClick: (function (param) {
                    Curry._1(cb, undefined);
                  })
              });
  }
}

var BehaviourMarkButton = {
  make: PilotQuestionContent$BehaviourMarkButton
};

function PilotQuestionContent$BackButton(props) {
  return React.createElement(PilotQuestionContent$Button, {
              onClick: props.onClick,
              className: "justify-self-start bg-transparent text-pilotButton hover:text-pilotHoverButton",
              children: null
            }, React.createElement(PrevArrow$LiteracyplanetTupperware.make, {
                  className: "h-[40%] fill-pilotButton hover:fill-pilotHoverButton mr-4"
                }), React.createElement("div", undefined, "Back"));
}

var BackButton = {
  make: PilotQuestionContent$BackButton
};

function PilotQuestionContent$BehaviourBackButton(props) {
  var match = V2ExerciseContext$LiteracyplanetTupperware.use();
  if (match.currentQuestionIndex === 0) {
    return React.createElement("div", undefined);
  }
  var onPreviousQuestion = match.onPreviousQuestion;
  return React.createElement(PilotQuestionContent$BackButton, {
              onClick: (function (param) {
                  Curry._1(onPreviousQuestion, undefined);
                })
            });
}

var BehaviourBackButton = {
  make: PilotQuestionContent$BehaviourBackButton
};

function PilotQuestionContent$NextButton(props) {
  return React.createElement(PilotQuestionContent$Button, {
              onClick: props.onClick,
              className: "justify-self-end bg-transparent text-pilotButton hover:text-pilotHoverButton",
              children: null
            }, React.createElement("div", undefined, "Next"), React.createElement(NextArrow$LiteracyplanetTupperware.make, {
                  className: "h-[40%] fill-pilotButton hover:fill-pilotHoverButton ml-4"
                }));
}

var NextButton = {
  make: PilotQuestionContent$NextButton
};

function PilotQuestionContent$BehaviourNextButton(props) {
  var match = V2ExerciseContext$LiteracyplanetTupperware.use();
  var onNextQuestion = match.onNextQuestion;
  return React.createElement(PilotQuestionContent$NextButton, {
              onClick: (function (param) {
                  Curry._1(onNextQuestion, undefined);
                })
            });
}

var BehaviourNextButton = {
  make: PilotQuestionContent$BehaviourNextButton
};

function PilotQuestionContent$MarkStatusPanel(props) {
  return React.createElement("div", {
              className: TailwindMerge.twMerge("w-full grid items-center justify-center border-solid h-20 mb-8 border-2", props.className)
            }, props.children);
}

var MarkStatusPanel = {
  make: PilotQuestionContent$MarkStatusPanel
};

function PilotQuestionContent$ShowCorrectAnswerButton(props) {
  return React.createElement(PilotQuestionContent$Button, {
              onClick: props.onClick,
              className: "w-52 justify-self-center text-pilotButton bg-pilotFooter border-4 border-pilotButton",
              children: props.text
            });
}

var ShowCorrectAnswerButton = {
  make: PilotQuestionContent$ShowCorrectAnswerButton
};

function PilotQuestionContent$BehaviourShowCorrectAnswerButton(props) {
  var match = V2ExerciseContext$LiteracyplanetTupperware.use();
  var onToggleShowCorrectAnswer = match.onToggleShowCorrectAnswer;
  var currentQuestionIndex = match.currentQuestionIndex;
  var answerVisible = Curry._1(match.isCorrectAnswerVisible, currentQuestionIndex);
  var marked = Curry._1(match.getMarkState, currentQuestionIndex);
  var onClick = function (param) {
    Curry._1(onToggleShowCorrectAnswer, undefined);
  };
  if (answerVisible !== undefined) {
    if (answerVisible) {
      return React.createElement(PilotQuestionContent$ShowCorrectAnswerButton, {
                  text: "Show My Answer",
                  onClick: onClick
                });
    }
    if (typeof marked === "object" && !marked._0.questionCorrect) {
      return React.createElement(PilotQuestionContent$ShowCorrectAnswerButton, {
                  text: "Show Correct Answer",
                  onClick: onClick
                });
    }
    
  }
  if (typeof marked !== "object") {
    return null;
  } else {
    return React.createElement("div", undefined);
  }
}

var BehaviourShowCorrectAnswerButton = {
  make: PilotQuestionContent$BehaviourShowCorrectAnswerButton
};

var enabledCss = Skillet$LiteracyplanetTupperware.BehaviourMarkButton.enabledCss;

function PilotQuestionContent$BehaviourMarkAllButton(props) {
  var match = V2ExerciseContext$LiteracyplanetTupperware.use();
  var activityEnded = match.activityEnded;
  var onSetActivityEnd = match.onSetActivityEnd;
  var onMarkActivity = match.onMarkActivity;
  if (match.finishedLastQuestion) {
    if (!activityEnded) {
      return React.createElement(PilotQuestionContent$Button, {
                  onClick: (function (param) {
                      Curry._1(onSetActivityEnd, undefined);
                    }),
                  className: "justify-self-center text-white bg-pilotButton hover:bg-pilotHoverButton",
                  children: "Continue"
                });
    }
    
  } else if (!activityEnded) {
    return React.createElement(PilotQuestionContent$MarkButton, {
                className: "justify-self-center text-white bg-pilotButton hover:bg-pilotHoverButton",
                onClick: (function (param) {
                    Curry._1(onMarkActivity, undefined);
                  })
              });
  }
  return React.createElement(PilotQuestionContent$Button, {
              onClick: (function (param) {
                  
                }),
              className: "justify-self-center text-white bg-pilotDisabledButton cursor-auto",
              children: "Continue"
            });
}

var BehaviourMarkAllButton = {
  enabledCss: enabledCss,
  make: PilotQuestionContent$BehaviourMarkAllButton
};

function PilotQuestionContent(props) {
  var match = V2ExerciseContext$LiteracyplanetTupperware.use();
  var isEndscreenShowing = match.isEndscreenShowing;
  var currentQuestionIndex = match.currentQuestionIndex;
  var answerShape = Curry._1(match.getMarkState, currentQuestionIndex);
  var tmp;
  tmp = typeof answerShape !== "object" ? null : (
      answerShape._0.questionCorrect || Curry._1(match.isCorrectAnswerVisible, currentQuestionIndex) === true ? React.createElement(PilotQuestionContent$MarkStatusPanel, {
              className: "bg-lpTickBackground border-lpTick MarkStatusPanelCorrect",
              children: React.createElement(TickIcon$LiteracyplanetTupperware.make, {
                    className: "h-1/2 ml-2 mr-2 fill-lpTick"
                  })
            }) : React.createElement(PilotQuestionContent$MarkStatusPanel, {
              className: "bg-lpCrossBackground border-lpCross border-2 MarkStatusPanelIncorrect",
              children: React.createElement(CrossIcon$LiteracyplanetTupperware.make, {
                    className: "h-1/2 ml-2 mr-2 fill-lpCross"
                  })
            })
    );
  return React.createElement(React.Fragment, {}, React.createElement("div", {
                  className: TailwindMerge.twMerge("h-[97vh] bg-white grid grid-rows-12", isEndscreenShowing ? "hidden" : "")
                }, React.createElement("div", {
                      className: "row-span-11 p-2.5 overflow-x-scroll"
                    }, tmp, props.children), React.createElement("div", {
                      className: "grid grid-cols-3 items-center bg-pilotFooter"
                    }, React.createElement(PilotQuestionContent$BehaviourBackButton, {}), React.createElement(PilotQuestionContent$BehaviourShowCorrectAnswerButton, {}), React.createElement(PilotQuestionContent$BehaviourMarkButton, {}), isEndscreenShowing ? React.createElement(PilotQuestionContent$BehaviourMarkAllButton, {}) : null, React.createElement(PilotQuestionContent$BehaviourNextButton, {}))), React.createElement("div", {
                  className: TailwindMerge.twMerge("h-[97vh] bg-white grid grid-rows-12", isEndscreenShowing ? "" : "hidden")
                }, React.createElement("div", {
                      className: "row-span-11 p-2.5 overflow-x-scroll"
                    }, isEndscreenShowing ? React.createElement(PilotEndScreenContainer$LiteracyplanetTupperware.make, {}) : null), React.createElement("div", {
                      className: "grid grid-cols-3 items-center bg-pilotFooter"
                    }, React.createElement(PilotQuestionContent$BehaviourBackButton, {}), isEndscreenShowing ? React.createElement(PilotQuestionContent$BehaviourMarkAllButton, {}) : null)));
}

var make = PilotQuestionContent;

export {
  Button ,
  MarkButton ,
  BehaviourMarkButton ,
  BackButton ,
  BehaviourBackButton ,
  NextButton ,
  BehaviourNextButton ,
  MarkStatusPanel ,
  ShowCorrectAnswerButton ,
  BehaviourShowCorrectAnswerButton ,
  BehaviourMarkAllButton ,
  make ,
}
/* react Not a pure module */
